export interface Pain {
  title: string
  intro?: string
  bullets: string[]
  closing: string[]
}

export const pains: Pain[] = [
  {
    title: '😰 Ogni settimana devi preparare tutto',
    bullets: [
      'Definire gli obiettivi.',
      'Organizzare le sessioni.',
      'Cercare attività adeguate.',
      'Preparare esercizi e materiali.',
      'Adattare il livello di difficoltà.',
      'Registrare i progressi.',
      'Pianificare il lavoro successivo.',
    ],
    closing: [
      'E prima ancora che inizi la sessione...',
      'Hai già dedicato molto tempo alla preparazione.',
    ],
  },
  {
    title: '🤔 Ogni paziente richiede un intervento diverso',
    bullets: [
      "Alcuni lavorano sull'articolazione.",
      'Altri sulla fonologia.',
      'Altri ancora sul linguaggio ricettivo o espressivo.',
      'Vocabolario.',
      'Morfosintassi.',
      'Narrazione.',
      'Fluenza.',
      'Comunicazione funzionale.',
    ],
    closing: [
      'Ogni paziente presenta obiettivi, livelli e necessità differenti.',
      "E non puoi semplicemente utilizzare la stessa attività con tutti.",
    ],
  },
  {
    title: '📚 Hai tantissimo materiale... ma devi continuare a cercare',
    bullets: [
      'PDF.',
      'Schede.',
      'Cartelle.',
      'Appunti.',
      'Materiali stampabili.',
      'Risorse salvate nel computer.',
    ],
    closing: [
      'Negli anni hai raccolto moltissimo materiale professionale.',
      'Ma quando devi preparare una sessione specifica, devi ancora cercare, selezionare, modificare e organizzare.',
      "Ti manca un unico sistema strutturato e pronto all'uso.",
    ],
  },
  {
    title: '😩 Il lavoro non termina quando finisce la sessione',
    intro: 'Dopo ogni paziente ci sono ancora...',
    bullets: [
      'Note.',
      'Registrazioni.',
      'Obiettivi da verificare.',
      'Progressi da monitorare.',
      'Attività da adattare.',
      'Materiali da preparare.',
      'Sessioni successive da pianificare.',
    ],
    closing: [
      'Il risultato?',
      'Una parte importante del tuo tempo professionale viene assorbita dalla preparazione e dall\u2019organizzazione.',
    ],
  },
]
